<template>
  <div class="card-menu-container">
    <div class="card-menu-button-container" v-on:click.stop="openMenu" role="button">
      <img class="card-menu-button" :src="menuUrl">
    </div>
    <div class="card-menu" v-if="showMenu" v-click-outside="closeMenu" role="menu">
      <slot name="menuItems"/>
    </div>
  </div>
</template>

<script>
import menuUrl from '../../assets/icons/menu.svg';
import ClickOutside from '../../directives/click-outside';
import EventBus from '../../utils/event-bus';
import { CLOSE_CARD_MENU_EVENT } from './Card.consts.ts';

export default {
  name: 'CardMenu', // Internal, not exported
  directives: {
    ClickOutside,
  },
  props: {
    onMenuOpened: { // use for logging / side effects
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      showMenu: false,
      menuUrl,
    };
  },
  mounted() {
    EventBus.$on(CLOSE_CARD_MENU_EVENT, this.closeMenu);
  },
  destroyed() {
    EventBus.$off(CLOSE_CARD_MENU_EVENT, this.closeMenu);
  },
  methods: {
    openMenu() {
      EventBus.$emit(CLOSE_CARD_MENU_EVENT);
      this.showMenu = true;
      if (this.onMenuOpened) {
        this.onMenuOpened();
      }
    },
    closeMenu() {
      this.showMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './card-styles';

</style>
